import React from 'react';
import { useTheme } from '@/theme';
import { Flex, Text } from '@/components/ui';
import { formatDate, formatDueDateLine } from '@/utils/date';

interface Device {
  serial_number: string;
  cloud_user?: string;
  cloud_desc?: string;
  device_type?: string;
  manufacturer_date?: string;
  hw_version?: string;
  fw_version?: string;
  sensor_types?: string[];
  calibration_due_date?: string | null;
  calibration_interval?: number[];
  cal_due_day_num?: number | null;
  bump_test_due_date?: string | null;
  bump_interval?: number[];
  bump_due_day_num?: number | null;
  last_location?: string;
  last_connect?: string;
  modified_at?: string;
  fixed_latitude?: number | null;
  fixed_longitude?: number | null;
}

interface DeviceDetailTabProps {
  device: Device;
}

export const DeviceDetailTab: React.FC<DeviceDetailTabProps> = ({ device }) => {
  const { theme } = useTheme();

  return (
    <Flex direction="row" align="start" justify="start">
      {/* 메타데이터 섹션 */}
      <div
        style={{
          padding: '20px',
        }}
      >
        <div style={{}}>
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Cloud User
            </Text>
            <Text size="md">{device.cloud_user || '-'}</Text>
          </div>
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Cloud Description
            </Text>
            <Text size="md">{device.cloud_desc || '-'}</Text>
          </div>{' '}
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Fixed Latitude
            </Text>
            <Text size="md">
              {device.fixed_latitude !== null && device.fixed_latitude !== undefined
                ? device.fixed_latitude.toFixed(6)
                : '-'}
            </Text>
          </div>
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Fixed Longitude
            </Text>
            <Text size="md">
              {device.fixed_longitude !== null && device.fixed_longitude !== undefined
                ? device.fixed_longitude.toFixed(6)
                : '-'}
            </Text>
          </div>
        </div>
      </div>

      {/* 상세 정보 섹션 */}
      <div
        style={{
          padding: '20px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: theme.spacing[6],
          }}
        >
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              HW Version
            </Text>
            <Text size="md">{device.hw_version || '-'}</Text>
          </div>
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              FW Version
            </Text>
            <Text size="md">{device.fw_version || '-'}</Text>
          </div>{' '}
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Manufacturer Date
            </Text>
            <Text size="md">
              {device.manufacturer_date ? formatDate(device.manufacturer_date) : '-'}
            </Text>
          </div>
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Calibration Due Date
            </Text>
            <Text size="md">
              {formatDueDateLine(
                device.calibration_due_date,
                device.cal_due_day_num,
                device.calibration_interval
              )}
            </Text>
          </div>
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Bump Test Due Date
            </Text>
            <Text size="md">
              {formatDueDateLine(
                device.bump_test_due_date,
                device.bump_due_day_num,
                device.bump_interval
              )}
            </Text>
          </div>
          <div>
            <Text size="sm" color="textSecondary" style={{ marginBottom: theme.spacing[2] }}>
              Last Connect
            </Text>
            <Text size="md">{device.last_connect ? formatDate(device.last_connect) : '-'}</Text>
          </div>
        </div>
      </div>
    </Flex>
  );
};
